// @ts-strict-ignore
import { FormattedMessage } from 'react-intl';
import shallow from 'zustand/shallow';

import { useSubtitleCreditsQuery } from 'api';
import { useTalkPageContext } from 'components/pages/talks/slug/talk-page-context';
import useVideoPlayerStore from '../../store';

import type { JSX } from 'react';

export default function SubtitlesCredits(): JSX.Element {
  const { slug, subtitle } = useTalkPageContext();

  const { subtitleLanguage, nativeLanguage } = useVideoPlayerStore(state => {
    return {
      subtitleLanguage: state.requestedSubtitleLanguage || state.subtitle,
      nativeLanguage: state.nativeLanguage
    };
  }, shallow);

  const { data, loading, error } = useSubtitleCreditsQuery({
    variables: { id: slug, language: subtitleLanguage },
    ssr: false,
    skip: !subtitleLanguage || subtitleLanguage === 'OFF'
  });

  if (error) {
    throw error;
  }

  if (
    loading ||
    !data?.translation?.translator ||
    !subtitle ||
    subtitle === 'OFF'
  ) {
    return <></>;
  }

  return (
    <div className="flex flex-wrap items-center justify-center bg-gray-50 px-3 py-2 tracking-tightest text-gray-500">
      {data.translation.translator && (
        <div>
          {data.translation.language?.englishName}{' '}
          {nativeLanguage === subtitleLanguage ? (
            <FormattedMessage defaultMessage="transcription by" />
          ) : (
            <FormattedMessage defaultMessage="translation by" />
          )}{' '}
          <a href={data.translation.translator.profilePath}>
            <span className="font-bold text-gray-700">
              {data.translation.translator.name.full}
            </span>
          </a>
          .
        </div>
      )}
      {data.translation.reviewer && (
        <div className="ml-1">
          <FormattedMessage defaultMessage="Reviewed by" />{' '}
          <a href={data.translation.reviewer.profilePath}>
            <span className="font-bold text-gray-700">
              {data.translation.reviewer.name.full}
            </span>
          </a>
          .
        </div>
      )}
    </div>
  );
}
